import { render, staticRenderFns } from "./wxMaterialDrafts.vue?vue&type=template&id=1803ff56&scoped=true"
import script from "./wxMaterialDrafts.vue?vue&type=script&lang=js"
export * from "./wxMaterialDrafts.vue?vue&type=script&lang=js"
import style0 from "./wxMaterialDrafts.vue?vue&type=style&index=0&id=1803ff56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1803ff56",
  null
  
)

export default component.exports